import { ReactNode } from 'react';
import { IconChevronDown, IconChevronUp } from '@rossum/ui/icons/tabler';
import type { ButtonProps } from '@rossum/ui/material';
import { Button, SvgIcon, Typography } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

type StatisticsFilterDropdownProps = {
  children: ReactNode;
  open: boolean;
} & ButtonProps;

const StatisticsFilterDropdown = ({
  children,
  open,
  ...ButtonProps
}: StatisticsFilterDropdownProps) => (
  <Typography color="text.white">
    <Button
      endIcon={
        <SvgIcon fontSize="large">
          {open ? <IconChevronUp /> : <IconChevronDown />}
        </SvgIcon>
      }
      color={open ? 'primary' : 'inherit'}
      variant="outlined"
      size="medium"
      sx={{
        height: '40px',
        fontWeight: 'normal',
        fontSize: '13px',
        borderRadius: borderRadius('m'),
        borderColor: theme => theme.palette.divider,
      }}
      {...ButtonProps}
    >
      {children}
    </Button>
  </Typography>
);

export { StatisticsFilterDropdown };
